import React from 'react'
import styles from './user-type.styles'
import injectSheet from 'react-jss'
import { useMe } from 'pobble-components/dist/pobble-user'
import { SelectRole } from 'pobble-components/dist/select-role'

const UserType = ({ classes }) => {
  const { refetchMe } = useMe()
  //const roles = me.account.finish_signup_status.next_step.options.role_values
  return <SelectRole onSuccess={refetchMe} />
}

export default injectSheet(styles)(UserType)
